import { render } from "./LeaveDetails.vue?vue&type=template&id=4d5cee5e&scoped=true"
import script from "./LeaveDetails.vue?vue&type=script&lang=js"
export * from "./LeaveDetails.vue?vue&type=script&lang=js"

import "./LeaveDetails.vue?vue&type=style&index=0&id=4d5cee5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5cee5e"]])

export default __exports__